module.exports = __webpack_public_path__ + "img/05-illu-matome2021.744b6d89.png";